<template>
  <div class="login">
    <div class="box">
      <div class="loginImg"></div>
      <div class="wrap">
        <div class="logo"></div>
        <el-input placeholder="用户名" v-model="loginForm.account"></el-input>
        <el-input type="password" placeholder="密码" v-model="loginForm.password"></el-input>
        <div class="verification-code-container">
          <el-input
            id="code"
            class="codeInput"
            @keyup.native.enter="login"
            autocomplete="off"
            placeholder="验证码"
            v-model="loginForm.code"
          ></el-input>
          <div class="verification-code" @click="getCode">
            <el-image
              v-loading="codeLoading"
              @load="codeLoaded"
              @error="codeLoaded"
              element-loading-spinner="el-icon-loading"
              :src="codeUrl + '?' + 'id=' + randomId"
            >
              <div slot="error" class="image-slot">
                <span style="color: #aaa; font-size: 12px;">点击刷新</span>
              </div>
            </el-image>
          </div>
        </div>
        <el-button class="loginBtn" :loading="loading" type="danger" @click.stop="login"
          >登录</el-button
        >
      </div>
    </div>
    <div class="footer">
      版权所有 © 杭州金松优诺电器有限公司
      <span class="btn" @click="toRecords">浙ICP备12036815号</span>
      <span class="explain"
        ><img src="../../assets/filing.png" width="14" height="14" />浙公网安备
        33019202000394号</span
      ><br />
      CopyRight 2022Goldfish 金鱼集团 All Right Reserved.
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        code: ''
      },
      codeUrl: '/api/' + this.$api.common.code,
      loading: false,
      codeLoading: false,
      randomId: createRandomId()
    }
  },
  methods: {
    getCode() {
      if (this.loading || this.codeLoading) return
      this.codeLoading = true
      this.randomId = createRandomId()
    },
    login() {
      if (this.loginForm.account === '' || this.loginForm.password === '') {
        this.$message.error('账号密码不能为空')
      } else {
        this.loading = true
        this.$store
          .dispatch('login', { login: this.$api.common.login, data: this.loginForm })
          .then(() => {
            this.loading = false
            // 遍历权限，跳转第一个页面
            for (let i = 0; i < this.$store.state.menus.length; i++) {
              if (this.$store.state.menus[i].isPermission === 'Y') {
                if (this.$store.state.menus[i].childList) {
                  for (let j = 0; j < this.$store.state.menus[i].childList.length; j++) {
                    if (this.$store.state.menus[i].childList[j].isPermission === 'Y') {
                      this.$router.push(this.$store.state.menus[i].childList[j].url)
                      return false
                    }
                  }
                } else {
                  this.$router.push(this.$store.state.menus[i].url)
                  break
                }
              }
            }
          })
          .catch(() => {
            this.loading = false
            this.getCode()
          })
      }
    },
    toRecords() {
      window.open('https://beian.miit.gov.cn')
    },
    codeLoaded() {
      this.codeLoading = false
    }
  }
}

function createRandomId() {
  return Math.random().toString(16).slice(2)
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  min-width: 1280px;
  min-height: 768px;
  height: 100%;
  background-image: url('../../assets/login_bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -237px;
    margin-left: -425px;
    width: 850px;
    height: 474px;
    border-radius: 4px;
    .loginImg {
      float: left;
      width: 360px;
      height: 474px;
      background-image: url('../../assets/younuo_logo.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 4px 0 0 4px;
    }
    .wrap {
      float: left;
      padding: 100px 87px 0;
      width: 490px;
      height: 474px;
      opacity: 0.95;
      background: #ffffff;
      box-shadow: -5px 3px 16px 0 rgba(18, 20, 22, 0.05);
      border-radius: 0 4px 4px 0;
      .logo {
        width: 174px;
        height: 66px;
        background-image: url('../../assets/login_dl_word.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .codeInput {
        float: left;
        width: 216px;
      }
      /deep/ .verification-code {
        float: right;
        cursor: pointer;
        .el-image {
          height: 40px;
          line-height: 40px;
          .el-image__inner {
            width: 92px;
            height: 40px;
            border-radius: 4px;
          }
        }
      }
      /deep/ .el-input {
        input {
          margin-bottom: 24px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #333333;
          border: 1px solid #dcdcdc;
        }
      }
      .loginBtn {
        padding: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #ffffff;
        background-color: #005aab;
        border: none;
      }
    }
  }
  .footer {
    position: absolute;
    left: 0;
    bottom: 24px;
    width: 100%;
    height: 40px;
    line-height: 20px;
    font-size: 14px;
    color: #655d5b;
    text-align: center;
    .btn {
      color: #005aab;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .explain {
      margin-left: 4px;
      img {
        margin-right: 4px;
        vertical-align: middle;
      }
    }
  }
}
</style>
